export default __webpack_public_path__ + "static/media/app_store.593721ba.png";